import React from 'react';
import { Plus as LucidePlus } from 'lucide-react';

interface PlusProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Plus: React.FC<PlusProps> = ({ width = 24, height = 24, className, style }) => (
  <LucidePlus width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Plus;
